import * as React from "react"
import { FieldError, useFormContext } from "react-hook-form"
import { Checkbox as CCheckbox, CheckboxProps, FormControl, HStack } from "@chakra-ui/react"

import { InputError } from "./InputError"
import { InputLabel } from "./InputLabel"

interface Props extends CheckboxProps {
  name: string
  label?: React.ReactNode
  subLabel?: string
  helpText?: string
}

export const Checkbox = ({ label, subLabel, helpText, ...props }: Props) => {
  const {
    register,
    unregister,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext()
  const fieldError = errors?.[props.name] as FieldError | string
  React.useEffect(() => {
    return () => unregister(props.name)
  }, [props.name, unregister])
  const value = watch(props.name) as boolean
  return (
    <FormControl isInvalid={!!fieldError} mb={0} isRequired={props.isRequired}>
      <HStack w="100%" py={2}>
        <CCheckbox
          id={props.name}
          {...register(props.name)}
          isChecked={value}
          onChange={() => setValue(props.name, !value, { shouldDirty: true })}
          mb={0}
          colorScheme="pink"
          size="lg"
          type="checkbox"
          aria-label={label ? `${label} checkbox` : undefined}
          {...props}
        />
        <InputLabel
          htmlFor={props.name}
          label={label}
          subLabel={subLabel}
          helpText={helpText}
          name={props.name}
          mb={0}
        />
      </HStack>
      <InputError error={fieldError} />
    </FormControl>
  )
}
